// REQUESTS :update original price
import { API_BASE } from "../constants/constants";
import { PriceControllerApi } from "@iliotech/generated-api-v3";

// Create a cache map to store price results
const priceCache = new Map<string, any>();

// Helper function to generate cache key
const getCacheKey = (sourceId: string, sourceData: string, tradeDate: string, splitAdjusted?: boolean) => {
  return `${sourceId}-${sourceData}-${tradeDate}-${splitAdjusted}`;
};

export const getPrice = (
  sourceId: string,
  sourceData: string,
  tradeDate: string,
  splitAdjusted?: boolean
) => {
  const cacheKey = getCacheKey(sourceId, sourceData, tradeDate, splitAdjusted);
  
  // Check if we have a cached result
  if (priceCache.has(cacheKey)) {
    return Promise.resolve(priceCache.get(cacheKey));
  }

  const api = new PriceControllerApi(undefined, `${API_BASE}/api`);

  return api.getPriceForDate(
    sourceId,
    sourceData as any,
    tradeDate,
    splitAdjusted
  ).then(result => {
    // Cache the result before returning
    priceCache.set(cacheKey, result);
    return result;
  });
};
